const loadInterface = () => import('./Interface');

export { loadInterface };
